// Active-filter pills — <overflow-list> reflows off its OWN width, which for our content-sized
// list stops tracking the viewport once its placeholder is dropped (see jd-plp-filters.css).
// Reflow it from the toolbar's width instead, which the page grid drives. Observing the toolbar,
// not the list, also keeps a reflow from resizing the very box that triggered it.
(function () {
  const container = document.querySelector('.collection-wrapper');

  if (!container || typeof ResizeObserver === 'undefined') return;

  new ResizeObserver(function () {
    // Re-queried each time: facets re-renders replace the toolbar.
    const list = container.querySelector('.jd-plp-toolbar__pills');
    if (list) list.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
  }).observe(container);
})();

// PLP filters — "Trier" toggle. Native only exposes one drawer entry point ("Filtrer"); this adds
// a second one that shows the sort accordion only, inside the SAME #filters-drawer/form (a second
// dialog/form would drop active filters from the URL on sort change). The view is CSS-derived
// from the accordions' native `open` state (jd-plp-filters.css) — this script only flips `.open`
// booleans, the one piece of state morph.js preserves across a facets re-render.
(function () {
  const sortButton = document.getElementById('jd-sort-toggle-button');
  const filterButton = document.getElementById('jd-filter-toggle-button');
  const drawer = document.getElementById('filters-drawer');

  if (!drawer) return;

  function filterAccordions() {
    return drawer.querySelectorAll('.facets__filters-wrapper details');
  }

  function sortAccordion() {
    return drawer.querySelector('details[id^="Sorting-"]');
  }

  function showDialog() {
    if (typeof drawer.showDialog === 'function') drawer.showDialog();
  }

  // Reopening the drawer restores the accordions as the user left them; only the very first open
  // falls back to the design default (first filter only). Keyed by details id rather than index:
  // a re-render can drop a filter whose options no longer match.
  //
  // The state is captured at the two moments the user leaves the filter view, rather than by
  // watching `toggle`: that event fires asynchronously, so a flag guarding our own opens/closes is
  // already back down when it arrives, and the Trier switch closing every filter gets recorded as
  // the user's choice.
  let remembered = null;

  function snapshot() {
    remembered = {};
    filterAccordions().forEach(function (details) {
      remembered[details.id] = details.open;
    });
  }

  function restoreOrDefault() {
    filterAccordions().forEach(function (details, index) {
      details.open = remembered ? remembered[details.id] === true : index === 0;
    });
  }

  // Closing the drawer records the layout — unless we're in the sort view, whose all-closed
  // filters are our own doing. `close` doesn't bubble, hence the capture phase.
  drawer.addEventListener(
    'close',
    function () {
      const sort = sortAccordion();
      if (sort && sort.open) return;
      snapshot();
    },
    true
  );

  // Native auto-close-details.js closes any <details> on an outside click — correct for the
  // native floating dropdown, but the "Trier" click that opens this accordion is itself outside
  // it, closing it again in the same event. Strip the attribute up front and after each
  // re-render (morph restores server-rendered attributes).
  function stripAutoClose() {
    const sort = sortAccordion();
    if (sort && sort.hasAttribute('data-auto-close-details')) sort.removeAttribute('data-auto-close-details');
  }

  stripAutoClose();
  new MutationObserver(stripAutoClose).observe(drawer, {
    attributes: true,
    attributeFilter: ['data-auto-close-details'],
    subtree: true,
  });

  if (sortButton) {
    sortButton.addEventListener('click', function () {
      stripAutoClose();
      // Leaving the filter view: record it before closing everything.
      snapshot();
      filterAccordions().forEach(function (details) {
        details.open = false;
      });
      const sort = sortAccordion();
      if (sort) sort.open = true;
      showDialog();
    });
  }

  if (filterButton) {
    filterButton.addEventListener('click', function () {
      restoreOrDefault();
      const sort = sortAccordion();
      if (sort) sort.open = false;
      // Native on:click="#filters-drawer/showDialog" on this same button already opens it.
    });
  }

  // Native updateFilterAndSorting (facets.js) only closes the sort <details> on selection, not
  // the dialog — leaves the wrong "Filtrer" styling flashing before the section re-render.
  // Closing the whole drawer avoids that.
  //
  // Delegated on `document`, not scoped to `#filters-drawer`: native sorting.liquid gives the
  // hidden desktop horizontal-bar radio and the drawer's radio the SAME id, so a label click on
  // the drawer's visible radio resolves via getElementById to the FIRST (hidden) match, whose
  // `closest('#filters-drawer')` is false. Harmless unscoped since the hidden instance is never
  // user-reachable.
  // Close the drawer once the re-render has LANDED, not the instant the sort is picked. Facets
  // re-renders the section asynchronously (fetch + morph); closing immediately would slide the
  // panel away and then let the grid pop to the new order a beat later — two disjoint motions.
  // Waiting for the grid to morph, then closing, hides the reorder behind the backdrop: the drawer
  // slides off an already-sorted grid. `data-skip-node-update` on the <dialog> (blocks/filters.liquid)
  // keeps the morph — which runs while the drawer is still open — from stripping its `open` state.
  document.addEventListener('change', function (event) {
    if (!(event.target instanceof Element && event.target.matches('.sorting-filter__input'))) return;
    if (typeof drawer.closeDialog !== 'function') return;

    var track = drawer.ownerDocument.querySelector('#ResultsList ul.product-grid');
    if (!track) {
      drawer.closeDialog();
      return;
    }

    var closed = false;
    function close() {
      if (closed) return;
      closed = true;
      observer.disconnect();
      clearTimeout(fallback);
      drawer.closeDialog();
    }
    // Morph reconciles the grid's children in place — first childList mutation = new order landed.
    var observer = new MutationObserver(close);
    observer.observe(track, { childList: true });
    // Safety net if the grid never mutates (network error, or identical order): close anyway.
    var fallback = setTimeout(close, 2500);
  });
})();
